import React, {useEffect, useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTimes} from "@fortawesome/free-solid-svg-icons";
import ReactModal from "react-modal";
import Select from "react-select";

import {BreadCrumbTrail} from "../../../../common/breadcrumb-trail/BreadcrumbTrail";
import facilityIcon from "../../../../../resources/images/facility-icon.png";
import {NextButton} from "../../../../common/button/next-button/NextButton";
import {BackButton} from "../../../../common/button/back-button/BackButton";
import {StandardButton} from "../../../../common/button/standard-button/StandardButton";
import {LeftLabelTextInput} from "../../../../common/input/left-label-text-input/LeftLabelTextInput";
import {createPerson, retrieveAllPersons} from "../../../../../services/PersonService";
import {ToolTip} from "../../../../common/tool-tip/ToolTip";
import {CommentToolTip} from "../../../../common/tool-tip-comments/CommentToolTip";
import {createPersonDropdownDisplayValue, sortPersonList} from "../../../../../util/PersonUtil";

export const TopicAreaThree = ({context, setContext, navigateTo, navigateBack, setSpinnerText, showToaster, toolTipsEnabled}) => {
    ReactModal.setAppElement('#root');

    const [allAccompanyingPersonList, setAllAccompanyingPersonList] = useState([]);
    const [availableAccompanyingPersonList, setAvailableAccompanyingPersonList] = useState([]);
    const [selectedAccompanyingPersonList, setSelectedAccompanyingPersonList] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [firstName, setFirstName] = useState(null);
    const [lastName, setLastName] = useState(null);
    const [organisation, setOrganisation] = useState(null);
    const [role, setRole] = useState(null);
    const [email, setEmail] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            setSpinnerText("Retrieving Accompanying Persons");
            const [data] = await retrieveAllPersons(context.username);
            if (data) {
                if (data.responseStatus === "Success") {
                    const mappedAccompanyingPersons = data.personVOList.map((person) => {
                        return {...person, displayValue: createPersonDropdownDisplayValue(person, true, true)}
                    });
                    sortPersonList(mappedAccompanyingPersons);
                    setAllAccompanyingPersonList(mappedAccompanyingPersons);
                }
            }
            setSpinnerText(null);
        };
        fetchData();
    }, []);

    useEffect(() => {
        if (context.topicAreaScreen) {
            if (context.topicAreaScreen.accompanyingPersonList) {
                setSelectedAccompanyingPersonList([...context.topicAreaScreen.accompanyingPersonList]);
                let filteredAvailableAccompanyingPersonList = allAccompanyingPersonList.filter((accompanyingPerson) => {
                    return !selectedAccompanyingPersonList.find((selectedAccompanyingPerson) => {
                        return (selectedAccompanyingPerson.externalReference === accompanyingPerson.externalReference && selectedAccompanyingPerson.displayValue === accompanyingPerson.displayValue)
                    });
                });
                setAvailableAccompanyingPersonList([...filteredAvailableAccompanyingPersonList]);
            } else {
                setAvailableAccompanyingPersonList([...allAccompanyingPersonList]);
            }
        }
    }, [allAccompanyingPersonList, context]);

    const handleAccompanyingPersonChange = (selectedAccompanyingPerson) => {
        setSelectedAccompanyingPersonList((prevState) => ([...prevState, selectedAccompanyingPerson]));
        let copyOfAvailableAccompanyingPersonList = [...availableAccompanyingPersonList];
        let index = copyOfAvailableAccompanyingPersonList.indexOf(selectedAccompanyingPerson);
        copyOfAvailableAccompanyingPersonList.splice(index, 1);
        sortPersonList(copyOfAvailableAccompanyingPersonList);
        setAvailableAccompanyingPersonList(copyOfAvailableAccompanyingPersonList);
    }

    const handleAccompanyingPersonClick = (selectedAccompanyingPerson) => {
        let copyOfSelectedAccompanyingPersonList = [...selectedAccompanyingPersonList];
        let index = copyOfSelectedAccompanyingPersonList.indexOf(selectedAccompanyingPerson);
        copyOfSelectedAccompanyingPersonList.splice(index, 1);
        setSelectedAccompanyingPersonList(copyOfSelectedAccompanyingPersonList);
        const copyOfAvailableAccompanyingPersonList = [...availableAccompanyingPersonList];
        copyOfAvailableAccompanyingPersonList.push(selectedAccompanyingPerson);
        sortPersonList(copyOfAvailableAccompanyingPersonList);
        setAvailableAccompanyingPersonList([...copyOfAvailableAccompanyingPersonList]);
    }

    const openModal = () => {
        setShowModal(true);
    }

    const closeModal = () => {
        setShowModal(false);
        setFirstName(null);
        setLastName(null);
        setEmail(null);
        setOrganisation(null);
        setRole(null);
    }

    const handleCreatePersonClick = async () => {
        setSpinnerText("Creating Person");
        const personToBeSaved = {firstName, lastName, email, organisation, organisationRole: role, active: true};
        const [data, error] = await createPerson(context.username, personToBeSaved);
        if (data) {
            showToaster(data);
            if (data.responseStatus === "Success") {
                const savedPerson = data.savedPersonVO;
                handleAccompanyingPersonChange({
                    ...savedPerson,
                    displayValue: createPersonDropdownDisplayValue(savedPerson, true, true),
                });
                closeModal();
            }
            setSpinnerText(null);
        } else {
            showToaster({
                responseStatus: "Error",
                responseMessage: error.message,
            });
            setSpinnerText(null);
        }
    }

    const handleNextClick = () => {
        setContext((prevState) => ({
            ...prevState,
            topicAreaScreen: {...prevState.topicAreaScreen, accompanyingPersonList: selectedAccompanyingPersonList}
        }));
        navigateTo("topicAreaFour");
    }

    const selectedAccompanyingPersonListItems = selectedAccompanyingPersonList.map((selectedAccompanyingPerson) => {
        return (
            <div className="list-item-container" key={selectedAccompanyingPerson.externalReference}>
                <p className={context.editMode ? "list-item" : "disabled-list-item"}>{selectedAccompanyingPerson.displayValue}</p>
                <div className={context.editMode ? "list-item-delete-button" : "disabled-list-item-delete-button"}
                     onClick={context.editMode ? () => {handleAccompanyingPersonClick(selectedAccompanyingPerson)} : null}>
                    <FontAwesomeIcon className="list-item-delete-icon" icon={faTimes}/>
                </div>
            </div>
        );
    });

    return (
        <div className="wizard-content-container">
            <div className="wizard-main-content-container">
                <div className="wizard-left-container">
                    <div className="wizard-icon-container">
                        <img src={facilityIcon} alt="Aurum Logo" className="wizard-icon"/>
                    </div>
                    <p className="wizard-icon-label">{context.facilityScreen.locationBreadCrumbText}</p>
                </div>
                <div className="wizard-right-container">
                    <div className={"label-div-tooltip-o"}>
                        <label className="label">Accompanying Person(s):</label>
                        {toolTipsEnabled &&
                        <ToolTip tooltipExternalReference={"ta3accomppersons1"}
                                 context={context}
                                 setSpinnerText={setSpinnerText} showToaster={showToaster}
                                 fieldName={"Accompanying Person(s):"}/>}
                    </div>
                    {selectedAccompanyingPersonListItems}
                    <div className="input-container">
                        <Select options={availableAccompanyingPersonList}
                                getOptionLabel={(availableAccompanyingPerson) => availableAccompanyingPerson.displayValue}
                                getOptionValue={(availableAccompanyingPerson) => availableAccompanyingPerson.externalReference}
                                onChange={handleAccompanyingPersonChange}
                                isDisabled={!availableAccompanyingPersonList || !context.editMode}
                                value={null}
                                classNamePrefix="select"
                        />
                    </div>
                    <StandardButton text="Create Person" onClick={openModal} disabled={!context.editMode}/>
                    {context.viewMode &&
                    <CommentToolTip contextName={"Visit"} showToaster={showToaster} setSpinnerText={setSpinnerText}
                                    contextExternalReference={context.topicAreaScreen.visitExternalReference}
                                    context={context} toolTipsEnabled={toolTipsEnabled}/>}
                    {context.viewMode && <div className="back-to-overview-button-container">
                        <StandardButton text="Problem Overview" onClick={() => {
                            navigateTo("problemTree");
                        }}/>
                    </div>}
                    <div className="navigation-button-container">
                        <NextButton disabled={selectedAccompanyingPersonList.length === 0} onClick={handleNextClick}/>
                        <BackButton onClick={navigateBack}/>
                    </div>
                </div>
            </div>

            <div className="wizard-breadcrumb-container">
                <BreadCrumbTrail context={context} navigateTo={navigateTo}/>
            </div>

            <ReactModal isOpen={showModal} className="modal-content" overlayClassName="modal-overlay">
                <p className="modal-title">Create Person</p>
                <LeftLabelTextInput labelText="First Name:" handleChange={({target}) => {
                    setFirstName(target.value)
                }}/>
                <LeftLabelTextInput labelText="Last Name:" handleChange={({target}) => {
                    setLastName(target.value)
                }}/>
                <LeftLabelTextInput labelText="Email:" handleChange={({target}) => {
                    setEmail(target.value)
                }}/>
                <LeftLabelTextInput labelText="Organisation:" handleChange={({target}) => {
                    setOrganisation(target.value)
                }}/>
                <LeftLabelTextInput labelText="Organisation Role:" handleChange={({target}) => {
                    setRole(target.value)
                }}/>
                <div className="modal-button-container">
                    <StandardButton text="Create Person" onClick={handleCreatePersonClick}
                                    disabled={!firstName || !lastName || !organisation || !role}/>
                    <StandardButton text="Cancel" onClick={closeModal}/>
                </div>
            </ReactModal>
        </div>
    );
}
